import React from 'react'
import IconBase from './IconBase'

const Camera = props =>
  <IconBase viewBox="3274.8 13631.44 36.4 29.12" {...props}>
    <path transform="translate(3274.8 13621)" d="M18.2,20.92a5.46,5.46,0,1,0,5.46,5.46,5.46,5.46,0,0,0-5.46-5.46Zm14.56-5.46H28.392a1.621,1.621,0,0,1-1.437-1.036l-1.129-3.388A1.622,1.622,0,0,0,24.388,10H12.012a1.621,1.621,0,0,0-1.437,1.036l-1.13,3.388A1.622,1.622,0,0,1,8.008,15.46H3.64A3.651,3.651,0,0,0,0,19.1V35.48a3.651,3.651,0,0,0,3.64,3.64H32.76a3.651,3.651,0,0,0,3.64-3.64V19.1a3.651,3.651,0,0,0-3.64-3.64ZM18.2,35.48a9.1,9.1,0,1,1,9.1-9.1,9.1,9.1,0,0,1-9.1,9.1ZM31.486,21.645a1.274,1.274,0,1,1,1.274-1.274A1.274,1.274,0,0,1,31.486,21.645Z" />
  </IconBase>
export default Camera
